import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '../../ui/sheet';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { SheetCloseSticky } from '../sheet-close-variants/sticky';
import { useGlobalStore } from '@/stores/store';
import { AuthForm } from '@/components/auth';
import { LoginSheetTrigger } from './login-sheet-trigger';
import { cn } from '@/lib/utils';
import { useShallow } from 'zustand/react/shallow';
import { getGlobalStore } from '@/utils/store';
interface LoginSheetProps {
  className?: string;
}
const LoginSheet = ({ className }: LoginSheetProps) => {
  const { setIsAuthSheetOpen, setLogout } = getGlobalStore();

  const { isAuthenticated, isAuthSheetOpen, isAuthSheetLoading } =
    useGlobalStore(
      useShallow((store) => ({
        isAuthSheetOpen: store.authStore.isAuthSheetOpen,
        isAuthSheetLoading: store.authStore.isAuthSheetLoading,
        isAuthenticated: store.authStore.isAuthenticated,
      }))
    );

  const handleClose = () => {
    if (!isAuthenticated) {
      setLogout();
    }

    if (isAuthSheetLoading) return;

    setIsAuthSheetOpen(false);
  };

  return (
    <Sheet open={isAuthSheetOpen}>
      <LoginSheetTrigger
        onClick={() => setIsAuthSheetOpen(true)}
        className={cn(className, {
          hidden: isAuthenticated,
        })}
      />
      <SheetContent
        onCloseAutoFocus={(event) => event.preventDefault()}
        className="w-full sm:max-w-none md:max-w-[400px] lg:max-w-[510px] xl:max-w-[510px]"
      >
        <SheetCloseSticky onClose={() => handleClose()} />
        <SheetHeader>
          <VisuallyHidden.Root>
            <SheetTitle>Login Sheet</SheetTitle>
            <SheetDescription>Login Sheet Description</SheetDescription>
          </VisuallyHidden.Root>
        </SheetHeader>
        <div className="px-8 mt-4">
          <AuthForm />
        </div>
      </SheetContent>
    </Sheet>
  );
};
export { LoginSheet };
